import { render, staticRenderFns } from "./StockControlRecord.vue?vue&type=template&id=34ffca16&scoped=true&"
import script from "./StockControlRecord.vue?vue&type=script&lang=js&"
export * from "./StockControlRecord.vue?vue&type=script&lang=js&"
import style0 from "./StockControlRecord.vue?vue&type=style&index=0&id=34ffca16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ffca16",
  null
  
)

export default component.exports
import {QItem,QInnerLoading,QSpinnerGears,QField} from 'quasar'
component.options.components = Object.assign({QItem,QInnerLoading,QSpinnerGears,QField}, component.options.components || {})
